export const site = {
  name: "Hydepark Regency",
  tagline: "Hotel & Convention Center",
  phone: "+91 89431 95933",
  phoneRaw: "918943195933",
  address: "Manjakulam Rd, Valakkad, Palakkad, Kerala 678014",
  landmark: "Opposite Manjakulam Mosque, a short walk from the KSRTC bus stand",
  checkIn: "1:00 PM – 2:00 PM",
  checkOut: "Before 12:30 PM",
  bookingUrl: "https://www.booking.com/hotel/in/hydepark-regency.html",
  mapEmbed:
    "https://www.google.com/maps?q=Hydepark+Regency+Manjakulam+Rd+Valakkad+Palakkad&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Hydepark+Regency+Manjakulam+Rd+Valakkad+Palakkad",
};

export const navLinks = [
  { to: "/", label: "Home" },
  { to: "/rooms", label: "Rooms" },
  { to: "/amenities", label: "Amenities" },
  { to: "/events", label: "Events" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const stats = [
  { value: 4, suffix: "", label: "Room categories" },
  { value: 24, suffix: "h", label: "Front desk" },
  { value: 2200, suffix: "", prefix: "₹", label: "Rooms from, per night" },
  { value: 100, suffix: "%", label: "Air-conditioned rooms" },
];
